import { Logger } from '../logger/logger';
import { callAPI } from './base_client';

type APIRequestObj = {
  params?: Record<string, string>;
  payload: any;
  url: string;
};

export async function sendviaDirectAPI({
  params,
  payload,
  url,
}: APIRequestObj): Promise<{ success: boolean }> {
  try {
    let finalUrl = url;
    if (params) {
      const paramStr = new URLSearchParams(params).toString();
      finalUrl = url.includes('?')
        ? `${url}&${paramStr}`
        : `${url}?${paramStr}`;
    }
    const isQueued = navigator.sendBeacon(finalUrl, JSON.stringify(payload));
    return { success: isQueued };
  } catch (error) {
    Logger.error(
      'failed to send payload via sendBeacon, falling back to regular request',
      { error: error },
    );
    try {
      const resp = await callAPI({
        body: JSON.stringify(payload),
        method: 'POST',
        params,
        url,
      });
      return { success: resp.ok };
    } catch {
      return { success: false };
    }
  }
}
